import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class Plan extends Component {
    state = {
        
    }
    getPaymentApiCase = () => { //辨別 call 哪支 api 
        const { user: {plan}, user: {canITrial} } = this.props
        if (canITrial && plan === 'Free') return 'trial' // 免費試用
        if (plan === '' || plan === 'Free') return 'payment' // 購買
        else return 'upgrade' // 升級（ 若在試用中升級方案也是用升級 api ）
    }
    getPaymentTextCase = () => {
        const {
            user: { plan, isTrialing, canITrial},
        } = this.props;
        if(isTrialing) { //是否試用中
            return 'trialing' //試用中
        }
        if(!canITrial) { //不可試用
            return plan === 'Free' 
                    ? 'trialedOrCanceled' //已試用過，未購買過
                    : 'dad' //已購買過
        }
        else return 'canTrial' //未試用，未購買，非試用中
    }
    isButtonPurchased = (condition) => {
        const value = { Creator: 1, Brand: 2, Agency: 3}
        const { plan } = this.props.user
        if ( plan === 'Free') return false
        else {
            const buttonValue = value[condition]
            const planValue = value[plan]
            if (buttonValue <= planValue) return true
            else return false
        }
    }
    buttonText = (condition) => {
        // 區分按鈕文字
        const { isButtonPurchased, props: { user: {auth, plan, isTrialing, canITrial}, messages }} = this
        if (auth === 'notSignIn') // 顯示登入
            return messages.free_trial
        if(!isTrialing && plan === 'Free' && canITrial) // Free 方案且試用中顯示免費試用
            return messages.free_trial 
        if(!isButtonPurchased(condition)) //升級
            return messages.user_upgrade
        if(isTrialing) // 試用中
            return messages.using_free_trial 
        else 
            return messages.pricing_purchased // 已購買
    }
    render() {
        const { messages, user: { auth } } = this.props
        const { isButtonPurchased, getPaymentApiCase, getPaymentTextCase, buttonText } = this
        return (
            <React.Fragment>
                <NavWrap>
                    <Nav>CREATOR</Nav>
                    <Nav>BRAND</Nav>
                    <Nav>AGENCY</Nav>
                </NavWrap>
                <Container>
                    <React.Fragment>
                        <Title>
                            <div>{messages['pricing_rank_01']}</div>
                            <SubTitle>{messages['pricing_rank_02']}</SubTitle>
                            <SubTitle>{messages['pricing_rank_03']}</SubTitle>
                        </Title>
                        <Title>
                            <div>{messages['pricing_info_01']}</div>
                            <SubTitle>{messages['pricing_info_02']}</SubTitle>
                            <SubTitle>{messages['pricing_info_03']}</SubTitle>
                        </Title>
                        <Title>
                            <div>{messages['pricing_data_01']}</div>
                            <SubTitle>{messages['pricing_data_02']}</SubTitle>
                            <SubTitle>{messages['pricing_data_03']}</SubTitle>
                        </Title>
                        <Title>
                            <div>{messages['pricing_propoasal_01']}</div>
                            <SubTitle>{messages['pricing_propoasal_02']}</SubTitle>
                            <SubTitle>{messages['pricing_propoasal_03']}</SubTitle>
                            <SubTitle>{messages['pricing_propoasal_04']}</SubTitle>
                        </Title>
                        <Title>
                            <ColumnWrap paddingBottom={'.7rem'}>
                                <span>{messages.pricing}</span>
                                <SubTitle>＊USD</SubTitle>
                            </ColumnWrap>
                        </Title>
                    </React.Fragment>
                    <React.Fragment>
                        <RedPoint />
                        <RedPoint />
                        <RedPoint />
                        <div />
                        <RedPoint />
                        <RedPoint />
                        <div />
                        <RedPoint />
                        <RedPoint />
                        <div />
                        <div />
                        <RedPoint />
                    </React.Fragment>
                    <React.Fragment>
                        <Buy>
                            <BuyContentWrap>
                                <div>
                                    <BuyContent marginTop={'2rem'} highLight>$2.9</BuyContent>
                                    <BuyContent marginTop={'2rem'}>{messages.pricing_month}</BuyContent>
                                </div>
                            </BuyContentWrap>
                            <BuyButton id={auth === 'notSignIn' ? 'ga_login_pricing' : `ga_creator${getPaymentApiCase()}`} onClick={() => {
                                auth === 'notSignIn' 
                                    ? window.innerWidth > 1080 
                                        ? this.props.dispatch({ type: 'toggleUserField', condition: 'signIn' })
                                        : this.props.history.push('/UserMobile')
            
                                    : !isButtonPurchased('Creator') && this.props.dispatch({ 
                                        type: 'togglePaymentField', 
                                        isPaymentActive: true, 
                                        paymentApiCase: getPaymentApiCase(), 
                                        paymentTextCase: getPaymentTextCase(), 
                                        buyPlan: 'Creator', buyAmount: '$2.9' })
                            }}
                                isActive={!isButtonPurchased("Creator")}
                            >
                                {buttonText('Creator')}
                            </BuyButton>
                        </Buy>
                        <Buy>
                            <BuyContentWrap>
                                <div>
                                    <BuyContent marginTop={'2rem'} highLight>$99</BuyContent>
                                    <BuyContent marginTop={'2rem'}>{messages.pricing_month}</BuyContent>
                                </div>
                            </BuyContentWrap>
                            <BuyButton id={auth === 'notSignIn' ? 'ga_login_pricing' : `ga_brand${getPaymentApiCase()}`} onClick={() => {
                                auth === 'notSignIn'
                                    ? window.innerWidth > 1080
                                        ? this.props.dispatch({ type: 'toggleUserField', condition: 'signIn' })
                                        : this.props.history.push('/UserMobile')

                                    : !isButtonPurchased('Brand') && this.props.dispatch({ 
                                        type: 'togglePaymentField', 
                                        isPaymentActive: true, 
                                        paymentApiCase: getPaymentApiCase(), 
                                        paymentTextCase: getPaymentTextCase(),
                                        buyPlan: 'Brand', 
                                        buyAmount: '$99' })
                            }}
                                isActive={!isButtonPurchased("Brand")}
                            >
                                {buttonText('Brand')}
                            </BuyButton>
                        </Buy>
                        <Buy>
                            <BuyContentWrap>
                                <ColumnWrap spaceBetween>
                                    <ColumnWrap>
                                        <BuyContent>{messages.pricing_agency_1to5_1}</BuyContent>
                                        <BuyContent >{messages.pricing_agency_per_user}</BuyContent>
                                        <div>
                                            <BuyContent highLight>$199</BuyContent>
                                            <BuyContent>{messages.pricing_month}</BuyContent>
                                        </div>
                                    </ColumnWrap>
                                    <ColumnWrap>
                                        <BuyContent>{messages.pricing_agency_6to10_1}</BuyContent>
                                        <BuyContent >{messages.pricing_agency_per_user}</BuyContent>
                                        <div>
                                            <BuyContent highLight>$99</BuyContent>
                                            <BuyContent>{messages.pricing_month}</BuyContent>
                                        </div>
                                    </ColumnWrap>
                                    <ColumnWrap>
                                        <BuyContent>{messages.pricing_agency_11up_1}</BuyContent>
                                        <BuyContent >{messages.pricing_agency_per_user}</BuyContent>
                                        <div>
                                            <BuyContent highLight>$29</BuyContent>
                                            <BuyContent>{messages.pricing_month}</BuyContent>
                                        </div>
                                    </ColumnWrap>
                                </ColumnWrap>
                            </BuyContentWrap>
                            <BuyButton id={auth === 'notSignIn' ? 'ga_login_pricing' : `ga_agency${getPaymentApiCase()}`} onClick={() => {
                                auth === 'notSignIn'
                                    ? window.innerWidth > 1080
                                        ? this.props.dispatch({ type: 'toggleUserField', condition: 'signIn' })
                                        : this.props.history.push('/UserMobile')

                                    : !isButtonPurchased('Agency') && this.props.history.push('/AgencyPayment/Payment')
                            }}
                                isActive={!isButtonPurchased("Agency")}
                            >
                                {buttonText('Agency')}
                            </BuyButton>
                        </Buy>
                    </React.Fragment>
                </Container>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        messages: state.Messages
    }
}
Plan.defaultProps = {
    user: {
        auth: 'notSignIn',
    }
}
export default withRouter(connect(mapStateToProps)(Plan));

const NavWrap = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr 2fr 2fr;
    grid-template-areas: 
    ". Nav1 Nav2 Nav3";
    width: 900px;
    font-size: 20px;
    @media (max-width: 900px){
        width: calc(100% - 40px);
        font-size: 12px;
    }  
`
const Nav = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    border-radius: 16px 16px 0 0;
    background-color: #e94242;
    font-weight: 500;
    color: #fff;
    @media (max-width: 900px){
        padding: 0;  
    } 
    &:nth-child(1) {
        grid-area: Nav1;
    }
    &:nth-child(2) {
        grid-area: Nav2;
    }
    &:nth-child(3) {
        grid-area: Nav3;
    }
`
const Container = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr 2fr 2fr;
    grid-template-rows: 400px repeat(4,auto);
    grid-template-areas: 
    "Title5 Buy1 Buy2 Buy3"
    "Title1 RedPoint1 RedPoint2 RedPoint3"
    "Title2 . RedPoint4 RedPoint5"
    "Title3 . RedPoint6 RedPoint7"
    "Title4 . . RedPoint8";
    width: 900px;
    margin-bottom: 32px;
    background-color: #dedede;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    grid-gap: 1px;
    * {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        font-size: 20px;
        font-weight: 500;
    }
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 0 20px 32px 20px;
        * {
            font-size: 12px;
            font-weight: 500;
        }
    }  
`
const Title = styled.div`
    display: flex;
    flex-direction: column;
    color: #787878;
    padding: 10px;
    text-align:center;
    &:nth-child(1) {
        grid-area: Title1;
    }
    &:nth-child(2) {
        grid-area: Title2;
    }
    &:nth-child(3) {
        grid-area: Title3;
    }
    &:nth-child(4) {
        grid-area: Title4;
    }
    &:nth-child(5) {
        grid-area: Title5;
    }
`
const SubTitle = styled.div`
    font-size: 14px;
    font-weight: 300;
    margin-top: 8px;
    @media (max-width: 900px){
        font-size: 12px;
    }  
`
const RedPoint = styled.div`
    position: relative;
    background-color: #fff;
    &:after {
        position: absolute;
        content: '';
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 16px;
        height: 16px;
        background-color: #e94242;
        border-radius: 100%;
    }
    &:nth-child(6) {
        grid-area: RedPoint1;
    }
    &:nth-child(7) {
        grid-area: RedPoint2;
    }
    &:nth-child(8) {
        grid-area: RedPoint3;
    }
    &:nth-child(10) {
        grid-area: RedPoint4;
    }
    &:nth-child(11) {
        grid-area: RedPoint5;
    }
    &:nth-child(13) {
        grid-area: RedPoint6;
    }
    &:nth-child(14) {
        grid-area: RedPoint7;
    }
    &:nth-child(17) {
        grid-area: RedPoint8;
    }
`
const Buy = styled.div`
    flex-direction: column;
    &:nth-child(18) {
        grid-area: Buy1;
    }
    &:nth-child(19) {
        grid-area: Buy2;
    }
    &:nth-child(20) {
        grid-area: Buy3;
    }
`
const BuyContentWrap = styled.div`
    width: 100%;
    height: 100%;
`
const ColumnWrap = styled.div`
    display: flex;
    flex-direction: column;
    ${({ spaceBetween }) => spaceBetween ? 'height: 100%; justify-content: space-around' : ''};
    width: 100%;
    border-bottom: 1px solid #dedede;
    padding-bottom: ${props => props.paddingBottom ? props.paddingBottom : ""};
    &:last-child {
        border-bottom: 0;
    }
`
const BuyContent = styled.div`
    color: ${props => props.highLight ? "#de0606" : "#787878"};
    font-size: ${props => props.highLight ? "24px" : "14px"};
    font-weight: ${props => props.highLight ? "500" : "300"};
    padding: ${props => props.highLight ? "0 5px" : ""};
    margin-top: ${props => props.marginTop ? props.marginTop : ""};
    @media (max-width: 900px){
        font-size: 12px;
    }
`
const BuyButton = styled.div`
    margin: 20px 10px;
    padding: 5px 30px;
    border-radius: 15px;
    background-color: ${props => props.isActive ? "#e94242" : "#a0a0a0"};
    cursor: ${props => props.isActive ? 'pointer' : 'not-allowed'};
    color: #fff;
    @media (max-width: 900px){
        padding: 5px;
    }
    text-align: center;  
`



// WEBPACK FOOTER //
// ./src/Pricing/Plan.js